/** Metadata belongs to the route, even when a portal gate hides its page. */
export function pageHead(title: string, description: string, path: string, privatePage = false, ogImage = '/og-image.jpg') {
  const fullTitle = title.includes('AKIVA') ? title : `${title} | AKIVA`;
  const canonical = new URL(path.replace(/\/$/, '') || '/', 'https://akiva.com').href;
  const image = new URL(ogImage, 'https://akiva.com').href;
  return {
    meta: [
      { title: fullTitle },
      { name: 'description', content: description },
      { property: 'og:title', content: fullTitle },
      { property: 'og:description', content: description },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: canonical },
      { property: 'og:site_name', content: 'AKIVA' },
      { property: 'og:image', content: image },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: fullTitle },
      { name: 'twitter:description', content: description },
      { name: 'twitter:image', content: image },
      { name: 'robots', content: privatePage ? 'noindex, nofollow' : 'index, follow' },
    ],
    links: [{ rel: 'canonical', href: canonical }],
  };
}
